export function hasInvitationQueryParameter(searchParams) {
  return (
    searchParams.has('invitation') ||
    searchParams.has('employer_invitation') ||
    searchParams.has('tax_advisor_invitation')
  )
}
